import { FilterTypeKey, FilterType, INumberFilter, IStringFilter, IEnumFilter } from '../../components/filters';
import { performanceFilters } from '../../components/filters/perfomance.filter';

export const sourcesFilters = new Map<FilterTypeKey, FilterType>([
	['numberFilters', { ...performanceFilters.numberFilters } as INumberFilter],
	['stringFilters', { ...performanceFilters.stringFilters, name: { columnName: 'Source', cellKey: 'source' } } as IStringFilter],
	[
		'enumFilters',
		{
			...performanceFilters.enumFilters,
		} as IEnumFilter,
	],
]);
